import { Injectable } from '@angular/core';
import { ToastService } from './toast.service';
import { Geolocation, Position, PermissionStatus, GeolocationPluginPermissions } from '@capacitor/geolocation';
import { NativeLayerService } from './native-layer.service';

@Injectable({
  providedIn: 'root'
})
export class GeolocationService {

    public loadingGeolocation;
    public accuracy;
    public positionData;

    constructor(
        public toast: ToastService,
        public native: NativeLayerService
    ) { }

    public async getPosition() {
        let permissions: (void | PermissionStatus) = await Geolocation.checkPermissions().catch(() => {
            this.toast.show('Habilite la ubicación en su dispositivo para que podamos obtener su ubicación.', 'warning');

            return;
        });

        if (!permissions) {
            this.toast.show('Habilite la ubicación en su dispositivo para que podamos obtener su ubicación.', 'warning');

            return;
        }

        if (permissions && permissions.location === 'denied' && this.native.isNative) {
            permissions = await Geolocation.requestPermissions();

            if (permissions && permissions.location === 'denied') {
                this.toast.show('Habilite ubicación de alta precisión para obtener una ubicación más fiable.', 'warning');

                return;
            }
        }
        this.loadingGeolocation = true;
        const positionData: (void | Position) = await Geolocation.getCurrentPosition({
            enableHighAccuracy: true,
            timeout: 16000,
            maximumAge: 1
        }).catch((e) => {
            this.toast.show('No se pudo obtener su ubicaión', 'warning');
        });
        this.loadingGeolocation = false;
        if (!positionData) {
            return;
        }
        // this.toast.show(`${positionData && positionData.coords.accuracy}`, 'warning');
        this.accuracy = Math.round(positionData.coords.accuracy);
        this.positionData = { lng: positionData.coords.longitude, lat: positionData.coords.latitude };

        return {
            accuracy: this.accuracy,
            positionData: this.positionData
        };
    }
}
